
































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class LogoCuisineConnectee extends Vue {
  @Prop({type: [Number, String], default: 75}) readonly width!: number | string;

  @Prop({type: [Number, String], default: 65}) readonly height!: number | string;
}
